import { Box, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const ZoomControls = ({ cardSize, onZoomIn, onZoomOut, minSize = 30, maxSize = 90 }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                position: 'absolute',
                bottom: '-3px',
                right: '0',
            }}
        >
            <IconButton
                onClick={onZoomOut}
                disabled={cardSize <= minSize}
                sx={{
                    width: 24,
                    height: 24,
                    opacity: 0.8,
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    },
                    '&:disabled': {
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        color: 'rgba(255, 255, 255, 0.3)',
                    },
                }}
            >
                <RemoveIcon
                    sx={{ fontSize: 14, background: '#26C6DA', color: '#fff', borderRadius: '50%' }}
                />
            </IconButton>

            <IconButton
                onClick={onZoomIn}
                disabled={cardSize >= maxSize}
                sx={{
                    width: 24,
                    height: 24,
                    opacity: 0.8,
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    },
                    '&:disabled': {
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        color: 'rgba(255, 255, 255, 0.3)',
                    },
                }}
            >
                <AddIcon sx={{ fontSize: 14, background: '#2196F3', color: '#fff', borderRadius: '50%' }} />
            </IconButton>
        </Box>
    );
};

export default ZoomControls;
